module.exports = __webpack_public_path__ + "img/voucher-code.7155cf60.png";